module.exports = "/assets/50a42aba52bb081ff72a7cc3e65b0f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/8U.png
// module id = 1148
// module chunks = 0